import React from "react"
import { toast } from "react-toastify"
import { profile } from '../stores/storages/ProfileStorage'
import { DOMAIN_FILE_DEFAULT, DOMAIN_IMG_DEFAULT, LINK_DOMAIN, DOMAIN_UPLOAD_FILE_DEFAULT } from '../config'
import { BACKGROUND_CHATS, NODE_TYPE_MESSAGE } from "../tinode/constants"
import MessagesUtil from "../tinode/messagesUtils"
import lodash from 'lodash'
import StringUtils from './string'

const Helpers = {

}

/**
 * Hàm trả về link download file
 *
 * @memberof Helpers
 * @static
 *
 * @param {String} relativeUrl
 * @returns link download file
 */
Helpers.getWebchatURL = (relativeUrl) => {
  if (!!relativeUrl && typeof relativeUrl === 'string') {
    if (relativeUrl.startsWith('http')) {
      return Helpers.formatURL(relativeUrl)
    }

    return `${LINK_DOMAIN}${relativeUrl}`
  }

  return null
}

/**
 * Hàm trả về link download file
 *
 * @memberof Helpers
 * @static
 *
 * @param {String} relativeUrl
 * @returns link download file
 */
Helpers.getDownloadURL = (relativeUrl) => {
  if (!!relativeUrl && typeof relativeUrl === 'string') {
    if (relativeUrl.startsWith('http')) {
      return Helpers.formatURL(relativeUrl)
    }

    const domain = profile && profile.changeDomain && profile.changeDomain.domain_img ? profile.changeDomain.domain_img : DOMAIN_FILE_DEFAULT
    return `https://${domain}${relativeUrl}`
  }

  return null
}

/**
 * Hàm trả về link avatar của người dùng
 *
 * @memberof Helpers
 * @static
 *
 * @param {String} user - Số điện thoại của người
 * @param {EpochTimeStamp} lavatar - Thời điểm cuối cùng người dùng cập nhật avatar
 *
 * @returns {String} link avatar của người dùng
 */
Helpers.getAvatarURL = (user, lavatar) => {
  const msisdn = profile.username;

  const domain = profile && profile.changeDomain && profile.changeDomain.domain_img ? profile.changeDomain.domain_img : DOMAIN_IMG_DEFAULT

  return `https://${domain}/api/thumbnail/download?ac=${encodeURIComponent(user)}&u=${encodeURIComponent(msisdn)}&t=${lavatar}`
}

/**
 * Hàm trả về link avatar của nhóm
 *
 * @memberof Helpers
 * @static
 *
 * @param {String} groupId - id nhóm
 * @param {EpochTimeStamp} avatarCreated - thời điểm tạo avatar
 * @returns {String} link avatar của nhóm
 */
Helpers.getAvatarGroupURL = (groupId, avatarCreated) => {
  const msisdn = profile.username;

  const domain = profile && profile.changeDomain && profile.changeDomain.domain_img ? profile.changeDomain.domain_img : DOMAIN_FILE_DEFAULT

  return `https://${domain}/api/group/download?ac=${encodeURIComponent(msisdn)}&groupid=${encodeURIComponent(groupId)}&lavatar=${avatarCreated}`
}

/**
 * Hàm trả về thông tin đường dẫn URL của sticker
 *
 * @memberof Helpers
 * @static
 *
 * @param {String} stickerPrefix - thông tin đường dẫn ứng với collection. Mỗi collection có một đường dẫn prefix khác nhau được tạo từ collectionId
 * @param {String} img - thông tin ảnh sticker trong collection được chọn
 *
 * @returns {String} đường dẫn URL của sticker
 */
Helpers.getStickerURL = (stickerPrefix, img) => {
  const domain = profile && profile.changeDomain && profile.changeDomain.domain_img ? profile.changeDomain.domain_img : DOMAIN_FILE_DEFAULT
  return `https://${domain}${stickerPrefix}/${img}`
}

Helpers.getDomainUpload = () => {
  // const domain = profile && profile.changeDomain && profile.changeDomain.domain_file ? profile.changeDomain.domain_file : DOMAIN_UPLOAD_FILE_DEFAULT_APP
  return `https://${DOMAIN_UPLOAD_FILE_DEFAULT}`
}

/**
 * Hàm trả về thông tin đường dẫn URL dạng https
 *
 * @memberof Helpers
 * @static
 *
 * @param {String} url - thông tin đường dẫn cần format
 *
 * @returns {String} đường dẫn URL đã được format dạng https
 */
Helpers.formatURL = (url) => {
  if (!!url && typeof url === 'string' && url.startsWith('http')) {
    return url.replace('http://', 'https://')
  }
  return `https://${profile.domain_image}/${url}`
}

/**
 * Hàm trả về thông tin extension theo tên file
 *
 * @memberof Helpers
 * @static
 *
 * @param {String} fileName - tên file cần xác định extension
 * @returns {String} thông tin extension của file
 */
Helpers.getFileExtension = (fileName) => {
  const lastDotIndex = fileName.lastIndexOf('.');

  if (lastDotIndex !== -1 && lastDotIndex !== 0) {
    return fileName.substring(lastDotIndex + 1);
  }
  return ''
}


/**
 * Hàm trả về mimeType của file dựa theo extension
 *
 * @memberof Helpers
 * @static
 *
 * @param {String} fileExtension - extension của file cần xác định mimeType
 * @returns {String} mimeType của file dựa theo extension
 */
Helpers.getMimeTypeFromExtension = (fileExtension) => {
  // Define a mapping of file extensions to MIME types
  const mimeTypes = {
    "aac": "audio/aac",
    "abw": "application/x-abiword",
    "arc": "application/x-freearc",
    "avif": "image/avif",
    "avi": "video/x-msvideo",
    "azw": "application/vnd.amazon.ebook",
    "bin": "application/octet-stream",
    "bmp": "image/bmp",
    "bz": "application/x-bzip",
    "bz2": "application/x-bzip2",
    "cda": "application/x-cdf",
    "csh": "application/x-csh",
    "css": "text/css",
    "csv": "text/csv",
    "doc": "application/msword",
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "eot": "application/vnd.ms-fontobject",
    "epub": "application/epub+zip",
    "gz": "application/gzip",
    "gif": "image/gif",
    "htm": "text/html",
    "html": "text/html",
    "ico": "image/vnd.microsoft.icon",
    "ics": "text/calendar",
    "jar": "application/java-archive",
    "jpeg": "image/jpeg",
    "jpg": "image/jpeg",
    "js": "text/javascript",
    "json": "application/json",
    "jsonld": "application/ld+json",
    "mid": "audio/midi",
    "mid": "audio/x-midi",
    "midi": "audio/midi",
    "midi": "audio/x-midi",
    "mjs": "text/javascript",
    "mp3": "audio/mpeg",
    "mp4": "video/mp4",
    "mpeg": "video/mpeg",
    "mpkg": "application/vnd.apple.installer+xml",
    "odp": "application/vnd.oasis.opendocument.presentation",
    "ods": "application/vnd.oasis.opendocument.spreadsheet",
    "odt": "application/vnd.oasis.opendocument.text",
    "oga": "audio/ogg",
    "ogv": "video/ogg",
    "ogx": "application/ogg",
    "opus": "audio/opus",
    "otf": "font/otf",
    "png": "image/png",
    "pdf": "application/pdf",
    "php": "application/x-httpd-php",
    "ppt": "application/vnd.ms-powerpoint",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "rar": "application/vnd.rar",
    "rtf": "application/rtf",
    "sh": "application/x-sh",
    "svg": "image/svg+xml",
    "tar": "application/x-tar",
    "tif": "image/tiff",
    "tiff": "image/tiff",
    "ts": "video/mp2t",
    "ttf": "font/ttf",
    "txt": "text/plain",
    "vsd": "application/vnd.visio",
    "wav": "audio/wav",
    "weba": "audio/webm",
    "webm": "video/webm",
    "webp": "image/webp",
    "woff": "font/woff",
    "woff2": "font/woff2",
    "xhtml": "application/xhtml+xml",
    "xls": "application/vnd.ms-excel",
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "xml": "application/xml",
    "xml": "text/xml",
    "xml": "application/atom+xml",
    "xml": "application/xml",
    "xul": "application/vnd.mozilla.xul+xml",
    "zip": "application/zip",
    "3gp": "video/3gpp",
    "3gp": "audio/3gpp",
    "3g2": "video/3gpp2",
    "3g2": "audio/3gpp2",
    "7z": "application/x-7z-compressed"
  };
  // Convert the file extension to lowercase (optional)
  fileExtension = fileExtension.toLowerCase();
  // Check if the extension exists in the mapping
  if (mimeTypes[fileExtension]) {
    return mimeTypes[fileExtension];
  } else {
    // Return a default MIME type or handle the case when the extension is not found
    return "application/octet-stream";
    // Default to binary data
  }
}

/**
 * Hàm trả về thông tin mimeType từ tên file
 * @memberof Helpers
 * @static
 *
 * @param {String} fileName - tên file cần xác định mimeType
 * @returns {String} thông tin mimeType từ tên file
 */
Helpers.getMimeType = (fileName) => {
  const extension = Helpers.getFileExtension(fileName || '')
  const mimeType = Helpers.getMimeTypeFromExtension(extension)
  return mimeType
}

/**
 * Hàm trả về thông tin trình duyệt có hỗ trợ Notification và người dùng đã granted Notification
 * @memberof Helpers
 * @static
 *
 * @returns {Boolean}
 */

Helpers.getGrantedNotificationBrower = () => {
  return 'Notification' in window && Notification && Notification.permission === 'granted';
}

/**
 * Hàm hiển thị toast thành công
 * @memberof Helpers
 * @static
 *
 * @param {String} message - message cần hiển thị
 * @returns {Boolean}
 */
Helpers.showSuccessToasts = (message) => {
  toast.dismiss();
  toast.success(
    <div style={{ display: 'flex' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div dangerouslySetInnerHTML={{
          __html: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="#3BB273"/>
                          </svg>`
        }} style={{ height: 20 }}>
        </div>
        <div style={{ marginLeft: 10 }}>
          <span style={{ fontSize: '14px', color: '#000000' }}>
            {message}
          </span>
        </div>
      </div>
    </div>
  )
}

/**
 * Hàm hiển thị toast lỗi
 * @memberof Helpers
 * @static
 *
 * @param {String} message - message cần hiển thị
 * @returns {Boolean}
 */
Helpers.showErrorToasts = (message) => {
  toast.dismiss();
  toast.error(
    <div style={{ display: 'flex' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div dangerouslySetInnerHTML={{
          __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
                      <path d="M2.47012 17.0001H17.5301C19.0701 17.0001 20.0301 15.3301 19.2601 14.0001L11.7301 0.990054C10.9601 -0.339946 9.04012 -0.339946 8.27012 0.990054L0.740121 14.0001C-0.0298788 15.3301 0.930121 17.0001 2.47012 17.0001ZM10.0001 10.0001C9.45012 10.0001 9.00012 9.55005 9.00012 9.00005V7.00005C9.00012 6.45005 9.45012 6.00005 10.0001 6.00005C10.5501 6.00005 11.0001 6.45005 11.0001 7.00005V9.00005C11.0001 9.55005 10.5501 10.0001 10.0001 10.0001ZM11.0001 14.0001H9.00012V12.0001H11.0001V14.0001Z" fill="#ED1B2F"/>
                      </svg>`
        }} style={{ height: 20 }}></div>
        <div style={{ marginLeft: 10 }}>
          <span style={{ fontSize: '14px', color: '#000000' }}>
            {message}
          </span>
        </div>
      </div>
    </div>
  )
}

/**
 * Hàm hiển thị toast warning
 * @memberof Helpers
 * @static
 *
 * @param {String} message - message cần hiển thị
 * @returns {Boolean}
 */
Helpers.showWarningToasts = (message) => {
  toast.dismiss();
  toast.warning(
    <div style={{ display: 'flex' }}>
      <div style={{ marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
        <div dangerouslySetInnerHTML={{
          __html: `<div class="icon"><i class="material-icons" style="color: #fbc02d;">warning</i></div>`
        }} style={{ height: 20 }}></div>
        <div style={{ marginLeft: 10 }}>
          <span style={{ fontSize: '14px', color: '#000000' }}>
            {message}
          </span>
        </div>
      </div>
    </div>
  )
}

Helpers.parse = (string) => {
  try {
    return JSON.parse(string);
  } catch (error) {
    return [];
  }
}

Helpers.removeMemberInVotes = (array, member) => {
  return array.map((value) => {
    if (typeof value.voters === 'object') {
      const index = value.voters.indexOf(member);
      if (index > -1) {
        value.voters.splice(index, 1)
      }
    } else {
      value.voters = [];
    }
    return value;
  });
}

Helpers.addMemberInVotes = (array, arrayVote, member) => {
  array = Helpers.removeMemberInVotes(array, member);
  arrayVote.forEach(value => {
    let index = array.findIndex(v => value.id === v.id);
    array[index]?.voters.push(member);
  });
  return array;
}

Helpers.getBackgroundSupport = (id) => {
  return BACKGROUND_CHATS[id] ? BACKGROUND_CHATS[id] : BACKGROUND_CHATS[5];
}

Helpers.sortByPrimaryName = (a, b) => {
  const pA = !!(a?.private?.comment);
  const pB = !!(b?.private?.comment);
  if (pA && pB) {
    return (b.touched || 0) - (a.touched || 0);
  }
  return pB - pA;
}

Helpers.getContentTags = (msg, tinode) => {
  const content = msg?.content;
  let msgReturn = typeof content === 'string'
    ? content
    : typeof content?.replyBody === 'string'
      ? content.replyBody
      : typeof content?.txt === 'string'
        ? content.txt
        : '';

  if (tinode == undefined) {
    return msgReturn;
  }

  const tags = Array.isArray(msg?.tags) && msg.tags.length > 0
    ? msg.tags
    : Array.isArray(content?.tags)
      ? content.tags
      : [];

  for (let index = 0; index < tags.length; index++) {
    const tag = tags[index];
    const { msisdn, tag_name } = tag;
    if (typeof tag_name !== 'string') {
      continue;
    }
    const topicId = MessagesUtil.getTopicId(NODE_TYPE_MESSAGE.CHAT, msisdn);
    const topic = tinode.getTopicByName(topicId);
    let name = lodash.has(tag, 'name') ? tag.name : tag_name;
    if (topic && topic.getTopicName()) {
      name = topic.getTopicName();
    }
    msgReturn = msgReturn.replace(tag_name, String(name || tag_name));
  }

  return msgReturn;
}

Helpers.downloadImageFile = (url, fileName) => {
  const xhr = new XMLHttpRequest();
  const parts = url.split('/');
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (xhr.status === 200) {
      const blob = xhr.response;
      const blobUrl = URL.createObjectURL(blob);
      var downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = fileName ? fileName : parts[parts.length - 1];
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
  xhr.onerror = function () {
    // window.open(url)
    Helpers.downloadImageFileWithRandomVersion(url, fileName)
  }
  xhr.send();
}

Helpers.downloadImageFileWithRandomVersion = (url, fileName) => {
  const xhr = new XMLHttpRequest();
  const parts = url.split('/');
  const newUrl = `${url}?v=${StringUtils.randomNumberStr(6)}`;
  xhr.open('GET', newUrl, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (xhr.status === 200) {
      const blob = xhr.response;
      const blobUrl = URL.createObjectURL(blob);
      var downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = fileName ? fileName : parts[parts.length - 1];
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
  xhr.onerror = function () {
    window.open(url)
  }
  xhr.send();
}

Helpers.filterSubsJid = (subs) => {
  try {
    return subs.filter((item, index) => {
      return subs.findIndex(x => x.jid === item.jid) === index;
    });
  } catch (error) {
    return subs;
  }
}

Helpers.isNullOrEmptyObject = (obj) => {
  return obj === null || (typeof obj === 'object' && Object.keys(obj).length === 0);
}

export default Helpers

